import { render, staticRenderFns } from "./StarNavBar.vue?vue&type=template&id=1d7bf590&scoped=true"
import script from "./StarNavBar.vue?vue&type=script&lang=js"
export * from "./StarNavBar.vue?vue&type=script&lang=js"
import style0 from "./StarNavBar.vue?vue&type=style&index=0&id=1d7bf590&prod&scoped=true&lang=scss"
import style1 from "./StarNavBar.vue?vue&type=style&index=1&id=1d7bf590&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7bf590",
  null
  
)

export default component.exports